module.exports = __webpack_public_path__ + "img/2.f2023e96.png";